<!-- Sidenav Actions Template -->
<ng-template #sitesSidenavActions>
  <br>
  <h4>Site Actions</h4>
  <br>
  <br>
  <button mat-button
    [disabled]="userRole == 'Viewer'"
    (click)="newSite()"
    color="primary">
    New Site
  </button>
  <br>
  <mat-divider></mat-divider>
  <button mat-button
    color="primary"
    (click)="exportCSV()">
    CSV
  </button>
  <br>
  <button mat-button
    color="primary"
    (click)="exportExcel()">
    Download as Excel
  </button>
  <br>
  <mat-divider></mat-divider>
  <button mat-button
    color="primary"
    (click)="customizeColumns()">
    Customize View
  </button>
  <br>
  <button mat-button
    color="primary"
    type="button"
    (click)="saveView()">
    Save As Default View
  </button>
  <br>
  <mat-divider></mat-divider>
  <button
    mat-button
    color="primary"
    type="button"
    [disabled]="true"
    (click)="showSaveNamedView()">
    Save View Now
  </button>
  <br>
  <button
    color="primary"
    mat-button
    type="button"
    [disabled]="true"
    (click)="openSavedReportsDialog()">
    Open Saved Views
  </button>
  <br>
  <button
    [disabled]="true"
    color="primary"
    mat-button
    type="button">
    Share View
  </button>
  <br>
  <mat-divider></mat-divider>
  <button
    color="primary"
    mat-button
    type="button"
    (click)="toggleInactiveSites()">
    {{ showInactiveSites ? 'Hide' : 'Show' }} Inactive Sites
  </button>
  <br>
  <br>
</ng-template>

<mat-sidenav-container class="example-container">
  <mat-sidenav-content>
    
    <mat-grid-list cols="12" rowHeight="40px">
      
      <!-- Header Section -->
      <mat-grid-tile [colspan]="12" [rowspan]="1">
        <h2>Sites Directory</h2>
      </mat-grid-tile>

      <!-- Search and Filter Controls -->
      <mat-grid-tile [colspan]="1" [rowspan]="2">
        <!-- Spacer -->
      </mat-grid-tile>

      <mat-grid-tile [colspan]="9" [rowspan]="2">
        <input
          type="text"
          class="filter-control"
          (input)="findTextInTableData($event.target.value)"
          placeholder="Search sites...">
      </mat-grid-tile>

      <mat-grid-tile [colspan]="2" [rowspan]="2">
        <div class="right-align">
          <!-- Results count could go here -->
        </div>
      </mat-grid-tile>

      <!-- Save Named View Section -->
      @if (showNameSavedView) {
        <mat-grid-tile [colspan]="4" [rowspan]="2">
          <mat-form-field class="full-width">
            <input
              matInput
              placeholder="Name this view"
              [(ngModel)]="nameOfSavedView"
              name="nameOfSavedView">
          </mat-form-field>
        </mat-grid-tile>
      }

      @if (showNameSavedView) {
        <mat-grid-tile [colspan]="2" [rowspan]="2">
          <div class="left-align">
            <button mat-flat-button
              color="primary"
              (click)="saveNamedViewNow()">
              Save
            </button>
          </div>
        </mat-grid-tile>
      }

      <!-- Load Saved Report Section -->
      @if (loadSavedReportVisible) {
        <mat-grid-tile [colspan]="3" [rowspan]="2">
          <mat-form-field class="full-width">
            <mat-select
              [(ngModel)]="savedViewToLoadName"
              name="savedViewToLoadName"
              placeholder="Select saved view">
              @for (view of savedUserViews; track view) {
                <mat-option [value]="view">
                  {{ view.savedViewName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>
      }

      <!-- Customize Columns Section -->
      @if (customizeColumnsUi) {
        <mat-grid-tile [colspan]="6" [rowspan]="2">
          <mat-form-field>
            <mat-select
              placeholder="Columns"
              [(ngModel)]="selectedCols"
              multiple
              (selectionChange)="selectionChanged($event.value)">
              @for (column of columnSelectList; track column) {
                <mat-option [value]="column.value">
                  {{ column.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>
      }

    </mat-grid-list>

    <!-- Sites Data Grid -->
    <ag-grid-angular
      style="width: 100%; height: 600px;"
      class="ag-theme-balham"
      [rowData]="allSites$ | async"
      [columnDefs]="defaultSiteViewCols"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="fixColumnWidths()"
      (cellClicked)="onCellClicked($event)">
    </ag-grid-angular>

  </mat-sidenav-content>
</mat-sidenav-container>

